import Connection from "@/data/Connection";

export default class PacketizationDiagramConfig {

    public collapsed:boolean = true;
    public connections:Array<Connection> = new Array<Connection>();
}
